import { render, staticRenderFns } from "./GittiGidiyor.vue?vue&type=template&id=06386311&scoped=true"
import script from "./GittiGidiyor.vue?vue&type=script&lang=js"
export * from "./GittiGidiyor.vue?vue&type=script&lang=js"
import style0 from "./GittiGidiyor.vue?vue&type=style&index=0&id=06386311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06386311",
  null
  
)

export default component.exports